<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="em-window">
        <div class="em-chrome">
          <span class="em-dot em-dot--r"></span>
          <span class="em-dot em-dot--y"></span>
          <span class="em-dot em-dot--g"></span>
          <span class="em-url">
            <span class="em-lock"></span>
            <span class="em-url-bar"></span>
          </span>
        </div>
        <div class="em-body">
          <div class="em-side">
            <span class="em-side-bar"></span>
            <span class="em-side-bar"></span>
            <span class="em-side-bar em-side-bar--short"></span>
          </div>
          <div class="em-content">
            <span class="em-bar em-bar--lg"></span>
            <span class="em-bar em-bar--md"></span>
            <span class="em-bar em-bar--md"></span>
            <span class="em-bar em-bar--sm"></span>
          </div>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewEmbed',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.em-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(15, 15, 20, 0.12);
  background: white;
  min-height: 150px;
}
.em-chrome {
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: #F4F4F8;
  border-bottom: 1px solid rgba(15, 15, 20, 0.08);
}
.em-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}
.em-dot--r { background: #FF5F57; }
.em-dot--y { background: #FEBC2E; }
.em-dot--g { background: #28C840; }
.em-url {
  margin-left: 6px;
  height: 14px;
  padding: 0 6px;
  border-radius: 4px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.1);
  display: flex;
  align-items: center;
  gap: 5px;
}
.em-lock {
  width: 6px;
  height: 6px;
  border-radius: 1px;
  background: rgba(15, 15, 20, 0.45);
}
.em-url-bar {
  flex: 1;
  height: 4px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.12);
}
.em-body {
  flex: 1;
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 12px;
  padding: 12px;
}
.em-side {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.em-side-bar {
  display: block;
  height: 7px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 25%, rgba(15, 15, 20, 0.05));
  width: 100%;
}
.em-side-bar--short { width: 60%; }
.em-content {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.em-bar {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.em-bar--lg { width: 70%; background: rgba(15, 15, 20, 0.2); }
.em-bar--md { width: 92%; }
.em-bar--sm { width: 50%; }
</style>
